import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import { getProfile, mergeIds } from '@/utils'
import merge from 'deepmerge'
import moment from 'moment'

const profile = getProfile()
const module = 'notifications'
let doc = {
  list: {
    name: 'Notifications',
    headers: [
      { label: 'Sujet', value: 'title' },
      { label: 'Message', value: 'message' },
      { label: 'Date', value: 'date', orig: 'created_at' },
    ],
    selectActions: [
      {
        label: 'Lu',
        icon: 'offline_pin',
        scope: ['notifications.update'],
        dispatch: `${module}/markRead`,
      },
    ],
  },

  form: {},

  postprocess: item => {
    let date = moment(item.created_at).format('DD/MM/YYYY')
    let isRead = item.read === 1
      ? 'oui'
      : 'non'
    return {
      ...item,
      isRead,
      date,
    }
  },
  params: {
    fetchAll: {},
    fetchOne: {},
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  actions: {
    fetchAll: ({ commit }, payload) => {
      commit('LIST_REQUEST', payload)
      apiClient.fetchCustom(module, `notifications/user/${profile.sub}`, {bust: Date.now()})
        .then(data => {
          if (data === 'cached') {
            commit('LIST_NOT_MODIFIED')
          } else {
            commit('LIST_SUCCESS', data)
          }
        })
        .catch(error => {
          commit('LIST_ERROR', error)
        })
    },
    markRead: ({ commit, dispatch }, payload) => {
      const { data } = payload
      commit('UPDATE_REQUEST', payload)
      let params = {id: mergeIds(data)}
      console.log(params)
      apiClient.batchPut(module, { read: 1 }, params)
        .then(response => {
          dispatch('fetchAll', {accessors: {}, context: {}, data: {}})
        })
        .catch(error => {
          commit('LIST_ERROR', error)
        })
    },
  },
}
export default merge(base, custom)
